var map = {
	"./general/DocsIcon--bluecheckmark.svg": 2805,
	"./general/DocsIcon--country.svg": 2806,
	"./general/DocsIcon--github.svg": 2807,
	"./general/DocsIcon--guide.svg": 2808,
	"./general/DocsIcon--list.svg": 2809,
	"./general/DocsIcon--locale.svg": 2810,
	"./general/DocsIcon--thumbsdown.svg": 2811,
	"./general/DocsIcon--thumbsup.svg": 2812,
	"./general/DocsIcon--video.svg": 2813,
	"./nav/DocsIcon--account.svg": 2814,
	"./nav/DocsIcon--business.svg": 2815,
	"./nav/DocsIcon--developertools.svg": 2816,
	"./nav/DocsIcon--financialservices.svg": 2817,
	"./nav/DocsIcon--home.svg": 2818,
	"./nav/DocsIcon--mobilenav.svg": 2819,
	"./nav/DocsIcon--payments.svg": 2820,
	"./nav/DocsIcon--reference.svg": 2821,
	"./nav/DocsIcon--security.svg": 2822,
	"./product/DocsIcon--account.svg": 2823,
	"./product/DocsIcon--atlas.svg": 2824,
	"./product/DocsIcon--capital.svg": 2825,
	"./product/DocsIcon--checkout.svg": 2826,
	"./product/DocsIcon--climate.svg": 2827,
	"./product/DocsIcon--connect.svg": 2828,
	"./product/DocsIcon--corporatecard.svg": 2829,
	"./product/DocsIcon--dashboard.svg": 2830,
	"./product/DocsIcon--developertools.svg": 2831,
	"./product/DocsIcon--elements.svg": 2832,
	"./product/DocsIcon--gateddocs.svg": 2833,
	"./product/DocsIcon--identity.svg": 2834,
	"./product/DocsIcon--implementationguides.svg": 2835,
	"./product/DocsIcon--invoicing.svg": 2836,
	"./product/DocsIcon--issuing.svg": 2837,
	"./product/DocsIcon--partners.svg": 2838,
	"./product/DocsIcon--payments.svg": 2839,
	"./product/DocsIcon--radar.svg": 2840,
	"./product/DocsIcon--reporting.svg": 2841,
	"./product/DocsIcon--sigma.svg": 2842,
	"./product/DocsIcon--styleguide.svg": 2843,
	"./product/DocsIcon--tax.svg": 2844,
	"./product/DocsIcon--terminal.svg": 2845,
	"./product/DocsIcon--treasury.svg": 2846
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2804;